import {BlockPageFallbackTypes} from 'interfaces'

export const selectBlockPageFallback = ({
  type,
  title,
  message,
}: {
  type: BlockPageFallbackTypes
  title: string
  message: string
}) => {
  const messageElement = getMessageElement(message, categoryReplacer)
  if (type === BlockPageFallbackTypes.defaultBlock)
    return `<!DOCTYPE html>
    <html lang="en">
      <head>
        <meta charset="UTF-8" />
        <meta http-equiv="X-UA-Compatible" content="IE=edge" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <link
          href="https://fonts.googleapis.com/css?family=Karla"
          rel="stylesheet"
        />
        <link
          rel="icon"
          type="image/png"
          sizes="16x16"
          href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAGUSURBVHgB7VbbsYIwEF3v3H+1AztQO7AEO1A7sAPtADqADqADoALoAKgAqCA3J3PDhJCg6Ac/OTM7mbx2j5s9iysiYrQgfmhhOAKOgCOwOIFfdXI6nehyuRgPdl1HeZ5TlmVUVRXZcD6fB/P1ek3b7VbciePYeIdJu16v7B0EQcB2ux1T72IeRdFoHbbZbFiSJCwMw9HeJIGyLIU1TTMigXU1GJzz7JkCDAi+TQABdAfP53NAAr9K7gP3+91KAMaf53MC0nQSvG56AnpWTE+hr81Wge/71LZtPz8cDmJM05R4cOJZEaMJ6j2J2QTgRHW03+/FeLvdqCgKEZxngnihClW9wtd9APIEILPj8SiIIBv8OUU2JBlbVoBZNUD/7y1hKzzUAvzBj8Tj8fi+CHWpThWdekcS8TzvcwKQkdoT0JDUfV6QkwrgnVTc09RgJoBA0Lk0vRmZJGdJcW+QrCrdSQJTACFT6rH+qhmBuJqBwccI8kIFm4C9uq7FB8V2BgqQfcEGnFFlvJJpWAruD4kj4Ag4An9X1ZrTdHPAMwAAAABJRU5ErkJggg=="
        />
        <title>Access Blocked</title>
    
        <style>
          body {
            margin: 0px;
            padding: 0px;
            color: #fff;
          }
          
          .primary-action {
            padding: 10px 32px;
            background: #00AEEA;
            border: none;
            color: #fff;
            float: right;
            border-radius: 2px;
            margin-top: 40px;
            font-weight: 700;
            font-size: 14px;
            line-height: 16px;
            text-transform: uppercase;
            letter-spacing: 0.75px;
            cursor: pointer;
          }

          .title {
            font-family: 'Karla';
            font-style: normal;
            font-weight: 700;
            padding: 0px;
            margin: 0px;
            margin-top: 5px;
            font-size: 24px;
            line-height: 28px;
            letter-spacing: 0px;
            text-align: left;
          }

          .body-message, .problem-label {
            font-weight: 400;
            font-size: 14px;
            line-height: 138.3%;
          }

          .url-label {
            font-family: 'Karla';
            font-style: normal;
            font-weight: 400;
            font-size: 14px;
            line-height: 138.3%;            
          }

          .url-section {
            margin: 32px 0px 24px 0px;
            font-size: 14px;
            font-weight: 400;
            line-height: 138.3%;
          }

          .url {
            color: #ff685f;
          }

          @media (prefers-color-scheme: dark) {
            .container {
              background-color: #1b1b1b;
              color: #fff;
            }
            ul {
              color: #fff;
            }
    
            ul li span {
              color: #999;
            }
            .svglock {
              stroke: #fff;
              stroke-width: 1.5px;
              stroke-linecap: round;
              stroke-linejoin: round;
            }

            .line-color {
              background: #F7F9FA;
            }

            .title, .body-message {
              color: #FFFFFF;
            }

            .problem-label, .url-section {
              color: #F7F9FA;
            }
          }
    
          @media (prefers-color-scheme: light) {
            .container {
              background-color: #fff;
              color: #1b1b1b;
            }
            ul {
              color: #1b1b1b;
            }
            ul li span {
              color: #6b6b6b;
            }
            .svglock {
              stroke: #1b1b1b;
              stroke-width: 1.5px;
              stroke-linecap: round;
              stroke-linejoin: round;
            }

            .line-color {
              background: #919699;
            }

            .title {
              color: #1E242B;
            }

            .body-message {
              color: #10151B;
            }

            .problem-label, .url-section {
              color: #919699;
            }
          }
        </style>
      </head>
      <body>
        <div
          class="container"
          style="
            width: 100%;
            height: 100vh;
            display: flex;
            justify-content: center;
            align-items: center;
            font-family: Karla;
          "
        >
          <section
            style="display: flex; justify-content: center; align-items: flex-start"
          >
            <div>
              <svg
                width="36"
                height="36"
                viewBox="0 0 36 36"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                class="svglock"
              >
                <path
                  d="M8.625 17.625C8.625 16.7966 9.29657 16.125 10.125 16.125H25.875C26.7034 16.125 27.375 16.7966 27.375 17.625V25.875C27.375 27.5319 26.0319 28.875 24.375 28.875H11.625C9.96815 28.875 8.625 27.5319 8.625 25.875V17.625Z"
                />
                <path
                  d="M11.625 15.75V15.514C11.625 13.1722 11.4841 10.5619 13.1197 8.88585C14.0524 7.93005 15.5618 7.125 18 7.125C20.4382 7.125 21.9476 7.93005 22.8803 8.88585C24.5159 10.5619 24.375 13.1722 24.375 15.514V15.75"
                />
              </svg>
            </div>
            <div style="padding: 0px 8px; max-width: 430px">
              <p class="title">
                ${title}
              </p>
              <p class="body-message" style="margin-top: 16px;">
                ${messageElement}
              </p>
              <div class="url-section">
                <p class="url-label" style="margin:0px;">
                  URL: <span class="url">%destination%</span>
                </p>
                <p class="url-label" style="margin:0px;">
                  CATEGORY: <span class="url">%category%</span>
                </p>
              </div>
    
              <hr
                style="
                  position: relative;
                  border: none;
                  height: 0.5px;
                "
                class="line-color"
              />
              <p class="problem-label" style="margin-top: 24px;">Problem? Contact your administrator.</p>
              <!-- <ul style="padding-left: 40px; font-size: smaller">
                <li>
                  <span style="text-decoration: underline"
                    >This category is incorrect</span
                  >
                  <svg
                    width="24"
                    height="8"
                    viewBox="0 0 24 8"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    style="margin-left: 5px"
                  >
                    <path
                      d="M23.3536 4.35355C23.5488 4.15829 23.5488 3.84171 23.3536 3.64645L20.1716 0.464466C19.9763 0.269204 19.6597 0.269204 19.4645 0.464466C19.2692 0.659728 19.2692 0.976311 19.4645 1.17157L22.2929 4L19.4645 6.82843C19.2692 7.02369 19.2692 7.34027 19.4645 7.53553C19.6597 7.7308 19.9763 7.7308 20.1716 7.53553L23.3536 4.35355ZM0 4.5H23V3.5H0V4.5Z"
                      fill="#919699"
                    />
                  </svg>
                </li>
                <li style="margin-top: 7px">
                  <span style="text-decoration: underline; padding-top: 5px"
                    >I need this for work</span
                  >
                  <svg
                    width="24"
                    height="8"
                    viewBox="0 0 24 8"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    style="margin-left: 5px"
                  >
                    <path
                      d="M23.3536 4.35355C23.5488 4.15829 23.5488 3.84171 23.3536 3.64645L20.1716 0.464466C19.9763 0.269204 19.6597 0.269204 19.4645 0.464466C19.2692 0.659728 19.2692 0.976311 19.4645 1.17157L22.2929 4L19.4645 6.82843C19.2692 7.02369 19.2692 7.34027 19.4645 7.53553C19.6597 7.7308 19.9763 7.7308 20.1716 7.53553L23.3536 4.35355ZM0 4.5H23V3.5H0V4.5Z"
                      fill="#919699"
                    />
                  </svg>
                </li>
              </ul> -->
              <button class="primary-action" id="primary_action_button" onclick="history.back()">
                GO BACK
              </button>
            </div>
          </section>
        </div>
      </body>
    </html>
    `
  else if (type === BlockPageFallbackTypes.defaultWarning)
    return `<!DOCTYPE html>
    <html lang="en">
      <head>
        <meta charset="UTF-8" />
        <meta http-equiv="X-UA-Compatible" content="IE=edge" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <link
          href="https://fonts.googleapis.com/css?family=Karla"
          rel="stylesheet"
        />
        <link
          rel="icon"
          type="image/png"
          sizes="16x16"
          href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAGUSURBVHgB7VbbsYIwEF3v3H+1AztQO7AEO1A7sAPtADqADqADoALoAKgAqCA3J3PDhJCg6Ac/OTM7mbx2j5s9iysiYrQgfmhhOAKOgCOwOIFfdXI6nehyuRgPdl1HeZ5TlmVUVRXZcD6fB/P1ek3b7VbciePYeIdJu16v7B0EQcB2ux1T72IeRdFoHbbZbFiSJCwMw9HeJIGyLIU1TTMigXU1GJzz7JkCDAi+TQABdAfP53NAAr9K7gP3+91KAMaf53MC0nQSvG56AnpWTE+hr81Wge/71LZtPz8cDmJM05R4cOJZEaMJ6j2J2QTgRHW03+/FeLvdqCgKEZxngnihClW9wtd9APIEILPj8SiIIBv8OUU2JBlbVoBZNUD/7y1hKzzUAvzBj8Tj8fi+CHWpThWdekcS8TzvcwKQkdoT0JDUfV6QkwrgnVTc09RgJoBA0Lk0vRmZJGdJcW+QrCrdSQJTACFT6rH+qhmBuJqBwccI8kIFm4C9uq7FB8V2BgqQfcEGnFFlvJJpWAruD4kj4Ag4An9X1ZrTdHPAMwAAAABJRU5ErkJggg=="
        />
        <title>Warning</title>
    
        <style>
          body {
            margin: 0px;
            padding: 0px;
            color: #fff;
          }

          .primary-action {
            padding: 10px 32px;
            background: #00AEEA;
            border: none;
            color: #fff;
            float: right;
            border-radius: 2px;
            margin-top: 40px;
            font-weight: 700;
            line-height: 16px;
            font-size: 14px;
            text-transform: uppercase;
            letter-spacing: 0.75px;
            cursor: pointer;
          }

          .title {
            font-family: 'Karla';
            font-style: normal;
            font-weight: 700;
            padding: 0px;
            margin: 0px;
            margin-top: 5px;
            font-size: 24px;
            line-height: 28px;
            letter-spacing: 0px;
            text-align: left;
          }

          .txt {
            padding: 10px 32px;
            font-weight: 700;
            line-height: 16px;
            font-size: 14px;
            color: #5E6366;
            margin-top: 40px;
            margin-right: 12px;
            border: none;
            background-color: transparent;
            text-transform: uppercase;
            letter-spacing: 0.75px;
            cursor: pointer;
          }

          .body-message, .problem-label, .url-label {
            font-family: 'Karla';
            font-style: normal;
            font-weight: 400;
            font-size: 14px;
            line-height: 138.3%;
          }

          .url-section {
            margin: 32px 0px 0px 0px;
            font-size: 14px;
          }

          @media (prefers-color-scheme: dark) {
            .container {
              background-color: #1b1b1b;
              color: #fff;
            }
            ul {
              color: #fff;
            }
    
            ul li span {
              color: #999;
            }

            .title, .body-message {
              color: #FFFFFF;
            }

            .problem-label, .url-section, .url-label {
              color: #F7F9FA;
            }

            .url {
              color: #919699;
            }
          }
    
          @media (prefers-color-scheme: light) {
            .container {
              background-color: #fff;
              color: #1b1b1b;
            }
            ul {
              color: #1b1b1b;
            }
            ul li span {
              color: #6b6b6b;
            }

            .title {
              color: #1E242B;
            }

            .body-message {
              color: #10151B;
            }

            .problem-label, .url-section, .url-label {
              color: #919699;
            }

            .url {
              color: #ff685f;
            }
          }
        </style>
      </head>
      <body>
        <div
          class="container"
          style="
            width: 100%;
            height: 100vh;
            display: flex;
            justify-content: center;
            align-items: center;
            font-family: Karla;
          "
        >
          <section
            style="
              display: flex;
              justify-content: center;
              align-items: flex-start;
              padding: 4px 0px;
            "
          >
            <div>
              <svg
                width="36"
                height="36"
                viewBox="0 0 36 36"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M19.681 9.29012C18.9897 7.91009 17.0203 7.90972 16.3285 9.28951L8.43395 25.035C7.80882 26.2818 8.71533 27.7504 10.1101 27.7504H25.8919C27.2863 27.7504 28.1928 26.2824 27.5683 25.0357L19.681 9.29012ZM14.3171 8.28105C15.8391 5.24554 20.1719 5.24633 21.6927 8.28241L29.58 24.0279C30.954 26.7708 28.9596 30.0004 25.8919 30.0004H10.1101C7.04163 30.0004 5.04732 26.7696 6.4226 24.0266L14.3171 8.28105Z"
                  fill="#F7C839"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M18 13.5C18.8284 13.5 19.5 14.1716 19.5 15V18C19.5 18.8284 18.8284 19.5 18 19.5C17.1716 19.5 16.5 18.8284 16.5 18V15C16.5 14.1716 17.1716 13.5 18 13.5Z"
                  fill="#F7C839"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M16.5 24C16.5 23.1716 17.1716 22.5 18 22.5C18.8284 22.5 19.5 23.1716 19.5 24C19.5 24.8284 18.8284 25.5 18 25.5C17.1716 25.5 16.5 24.8284 16.5 24Z"
                  fill="#F7C839"
                />
              </svg>
            </div>
            <div style="padding: 0px 7px; max-width: 430px">
              <p class="title">
                ${title}
              </p>
              <p class="body-message" style="margin-top: 16px;">
                ${message}
              </p>
              <div class="url-section">
                <p class="url-label" style="margin:0px;">
                  URL: <span class="url">%destination%</span>
                </p>
                <p class="url-label" style="margin:0px;">
                  CATEGORY: <span class="url">%category%</span>
                </p>
              </div>
    
              <hr
              style="
                position: relative;
                border: none;
                height: 0.5px;
                background: #919699;
              "
            />
    
            <p class="problem-label" style="margin-top: 24px;">Problem? Contact your administrator.</p>
              <div
                style="
                  display: flex;
                  justify-content: flex-end;
                  align-items: center;
                "
              >
                <button class="txt" id="secondary_action_button" onclick="history.back()">
                  go back
                </button>
                <button class="primary-action" id="primary_action_button" onclick="location.href='%accept_warning%';">
                  continue
                </button>
              </div>
            </div>
          </section>
        </div>
      </body>
    </html>
    `
  else if (type === BlockPageFallbackTypes.defaultSecurity)
    return `<!DOCTYPE html>
    <html lang="en">
      <head>
        <meta charset="UTF-8" />
        <meta http-equiv="X-UA-Compatible" content="IE=edge" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <link
          href="https://fonts.googleapis.com/css?family=Karla"
          rel="stylesheet"
        />
        <link
          rel="icon"
          type="image/png"
          sizes="16x16"
          href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAGUSURBVHgB7VbbsYIwEF3v3H+1AztQO7AEO1A7sAPtADqADqADoALoAKgAqCA3J3PDhJCg6Ac/OTM7mbx2j5s9iysiYrQgfmhhOAKOgCOwOIFfdXI6nehyuRgPdl1HeZ5TlmVUVRXZcD6fB/P1ek3b7VbciePYeIdJu16v7B0EQcB2ux1T72IeRdFoHbbZbFiSJCwMw9HeJIGyLIU1TTMigXU1GJzz7JkCDAi+TQABdAfP53NAAr9K7gP3+91KAMaf53MC0nQSvG56AnpWTE+hr81Wge/71LZtPz8cDmJM05R4cOJZEaMJ6j2J2QTgRHW03+/FeLvdqCgKEZxngnihClW9wtd9APIEILPj8SiIIBv8OUU2JBlbVoBZNUD/7y1hKzzUAvzBj8Tj8fi+CHWpThWdekcS8TzvcwKQkdoT0JDUfV6QkwrgnVTc09RgJoBA0Lk0vRmZJGdJcW+QrCrdSQJTACFT6rH+qhmBuJqBwccI8kIFm4C9uq7FB8V2BgqQfcEGnFFlvJJpWAruD4kj4Ag4An9X1ZrTdHPAMwAAAABJRU5ErkJggg=="
        />
        <title>Access Blocked</title>
        <style>
          body {
            margin: 0px;
            padding: 0px;
            color: #fff;
          }

          .title {
            padding: 0px;
            margin: 0px;
            margin-top: 5px;
            letter-spacing: 0px;
            text-align: left;
            font-family: 'Karla';
            font-style: normal;
            font-weight: 700;
            font-size: 24px;
            line-height: 28px;
          }

          .body-message, .url-label, .problem-label {
            font-family: 'Karla';
            font-style: normal;
            font-weight: 400;
            font-size: 14px;
            line-height: 138.3%;
          }

          .primary-action {
            padding: 10px 32px;
            background: #00AEEA;
            border: none;
            color: #fff;
            float: right;
            border-radius: 2px;
            margin-top: 40px;
            font-weight: 700;
            font-size: 14px;
            line-height: 16px;
            text-transform: uppercase;
            letter-spacing: 0.75px;
            cursor: pointer;
          }

          @media (prefers-color-scheme: dark) {
            .container {
              background-color: #1b1b1b;
              color: #fff;
            }
            ul {
              color: #fff;
            }
    
            ul li span {
              color: #999;
            }

            .title, .body-message {
              color: #FFFFFF;
            }

            .url-label, .problem-label {
              color: #F7F9FA;
            }
          }
    
          @media (prefers-color-scheme: light) {
            .container {
              background-color: #fff;
              color: #1b1b1b;
            }
            ul {
              color: #1b1b1b;
            }
            ul li span {
              color: #6b6b6b;
            }

            .title {
              color: #1E242B;
            }

            .body-message {
              color: #10151B;
            }

            .url-label, .problem-label {
              color: #919699;
            }
          }
        </style>
      </head>
      <body>
        <div
          class="container"
          style="
            width: 100%;
            height: 100vh;
            display: flex;
            justify-content: center;
            align-items: center;
            font-family: Karla;
          "
        >
          <section
            style="
              display: flex;
              justify-content: center;
              align-items: flex-start;
              padding: 4px 0px;
            "
          >
            <div>
              <svg
                width="36"
                height="36"
                viewBox="0 0 36 36"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M18 7.125L7.12497 12C7.12497 12 5.99997 28.875 18 28.875C30 28.875 28.875 12 28.875 12L18 7.125Z"
                  stroke="#FF685F"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M18 11.625C18.8284 11.625 19.5 12.4645 19.5 13.5V17.25C19.5 18.2855 18.8284 19.125 18 19.125C17.1716 19.125 16.5 18.2855 16.5 17.25V13.5C16.5 12.4645 17.1716 11.625 18 11.625Z"
                  fill="#FF685F"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M16.5 23.25C16.5 22.4216 17.1716 21.75 18 21.75C18.8284 21.75 19.5 22.4216 19.5 23.25C19.5 24.0784 18.8284 24.75 18 24.75C17.1716 24.75 16.5 24.0784 16.5 23.25Z"
                  fill="#FF685F"
                />
              </svg>
            </div>
            <div style="padding: 0px 7px; max-width: 430px">
              <p class="title">
                ${title}
              </p>
              <p class="body-message" style="margin-top: 16px">
               ${message}
              </p>
              <p class="url-label" style="margin: 32px 0px 4px 0px;">
                URL: <span style="color: #ff685f">%destination%</span>
              </p>
              <p class="url-label" style="margin: 0px 0px 24px 0px;">
                CATEGORY: <span style="color: #ff685f">%category%</span>
              </p>
    
              <hr
                style="
                  position: relative;
                  border: none;
                  height: 0.5px;
                  margin-top: 20px;
                  background: #919699;
                "
              />
    
              <p class="problem-label" style="margin-top: 24px;">Problem? Contact your administrator.</p>
              <button class="primary-action" id="primary_action_button" onclick="history.back()">
                GO BACK
              </button>
            </div>
          </section>
        </div>
      </body>
    </html>
    `
  else if (type === BlockPageFallbackTypes.defaultCloudApplication)
    return `<!DOCTYPE html>
    <html lang="en">
      <head>
        <meta charset="UTF-8" />
        <meta http-equiv="X-UA-Compatible" content="IE=edge" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <link
          href="https://fonts.googleapis.com/css?family=Karla"
          rel="stylesheet"
        />
        <link
          rel="icon"
          type="image/png"
          sizes="16x16"
          href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAGUSURBVHgB7VbbsYIwEF3v3H+1AztQO7AEO1A7sAPtADqADqADoALoAKgAqCA3J3PDhJCg6Ac/OTM7mbx2j5s9iysiYrQgfmhhOAKOgCOwOIFfdXI6nehyuRgPdl1HeZ5TlmVUVRXZcD6fB/P1ek3b7VbciePYeIdJu16v7B0EQcB2ux1T72IeRdFoHbbZbFiSJCwMw9HeJIGyLIU1TTMigXU1GJzz7JkCDAi+TQABdAfP53NAAr9K7gP3+91KAMaf53MC0nQSvG56AnpWTE+hr81Wge/71LZtPz8cDmJM05R4cOJZEaMJ6j2J2QTgRHW03+/FeLvdqCgKEZxngnihClW9wtd9APIEILPj8SiIIBv8OUU2JBlbVoBZNUD/7y1hKzzUAvzBj8Tj8fi+CHWpThWdekcS8TzvcwKQkdoT0JDUfV6QkwrgnVTc09RgJoBA0Lk0vRmZJGdJcW+QrCrdSQJTACFT6rH+qhmBuJqBwccI8kIFm4C9uq7FB8V2BgqQfcEGnFFlvJJpWAruD4kj4Ag4An9X1ZrTdHPAMwAAAABJRU5ErkJggg=="
        />
        <title>Application Restricted</title>
    
        <style>
          body {
            margin: 0px;
            padding: 0px;
            color: #fff;
          }

          .title {
            padding: 0px;
            margin: 0px;
            margin-top: 5px;
            letter-spacing: 0px;
            text-align: left;
            font-family: 'Karla';
            font-style: normal;
            font-weight: 700;
            font-size: 24px;
            line-height: 28px;
          }

          .body-message, .url-label, .problem-label {
            font-family: 'Karla';
            font-style: normal;
            font-weight: 400;
            font-size: 14px;
            line-height: 138.3%;
          }

          .primary-action {
            padding: 10px 32px;
            background: #00AEEA;
            border: none;
            color: #fff;
            float: right;
            border-radius: 2px;
            margin-top: 40px;
            font-weight: 700;
            font-size: 14px;
            line-height: 16px;
            text-transform: uppercase;
            letter-spacing: 0.75px;
            cursor: pointer;
          }

          @media (prefers-color-scheme: dark) {
            .container {
              background-color: #1b1b1b;
              color: #fff;
            }
            ul {
              color: #fff;
            }
    
            ul li span {
              color: #999;
            }

            .title, .body-message {
              color: #FFFFFF;
            }

            .url-label, .problem-label {
              color: #F7F9FA;
            }
          }
    
          @media (prefers-color-scheme: light) {
            .container {
              background-color: #fff;
              color: #1b1b1b;
            }
            ul {
              color: #1b1b1b;
            }
            ul li span {
              color: #6b6b6b;
            }

            .title {
              color: #1E242B;
            }

            .body-message {
              color: #10151B;
            }

            .url-label, .problem-label {
              color: #919699;
            }
          }
        </style>
      </head>
      <body>
        <div
          class="container"
          style="
            width: 100%;
            height: 100vh;
            display: flex;
            justify-content: center;
            align-items: center;
            font-family: Karla;
          "
        >
          <section
            style="
              display: flex;
              justify-content: center;
              align-items: flex-start;
              padding: 4px 0px;
            "
          >
            <div>
              <svg
                width="36"
                height="36"
                viewBox="0 0 36 36"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M7.125 12L18 7.125L28.875 12L18 16.875L7.125 12Z"
                  stroke="#FF685F"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M7.125 24L18 28.875L28.875 24"
                  stroke="#FF685F"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M28.875 12V24"
                  stroke="#FF685F"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M7.125 12V24"
                  stroke="#FF685F"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M18 17.25V28.5"
                  stroke="#FF685F"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
            <div style="padding: 0px 7px; max-width: 430px">
              <p class="title">
                ${title}
              </p>
              <p class="body-message" style="margin-top: 16px;">
                ${message}
              </p>
              <p class="url-label" style="margin: 32px 0px 4px 0px;">
                ALLOWED: <span style="color: #ff685f">%alloweddomains%</span>
              </p>
              <p class="url-label" style="margin-top: 0px; margin-bottom: 24px;">
                CLOUD APP: <span style="color: #ff685f">%category%</span>
              </p>
    
              <hr
                style="
                  position: relative;
                  border: none;
                  height: 0.5px;
                  margin-top: 20px;
                  background: #919699;
                "
              />
    
              <p class="problem-label" style="margin-top: 24px;">Problem? Contact your administrator.</p>
              <button class="primary-action" id="primary_action_button" onclick="history.back()">
                GO BACK
              </button>
            </div>
          </section>
        </div>
      </body>
    </html>
    `
  else
    return `<!DOCTYPE html>
  <html lang="en">
    <head>
      <meta charset="UTF-8" />
      <meta http-equiv="X-UA-Compatible" content="IE=edge" />
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      <link
        href="https://fonts.googleapis.com/css?family=Karla"
        rel="stylesheet"
      />
      <link
        rel="icon"
        type="image/png"
        sizes="16x16"
        href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAGUSURBVHgB7VbbsYIwEF3v3H+1AztQO7AEO1A7sAPtADqADqADoALoAKgAqCA3J3PDhJCg6Ac/OTM7mbx2j5s9iysiYrQgfmhhOAKOgCOwOIFfdXI6nehyuRgPdl1HeZ5TlmVUVRXZcD6fB/P1ek3b7VbciePYeIdJu16v7B0EQcB2ux1T72IeRdFoHbbZbFiSJCwMw9HeJIGyLIU1TTMigXU1GJzz7JkCDAi+TQABdAfP53NAAr9K7gP3+91KAMaf53MC0nQSvG56AnpWTE+hr81Wge/71LZtPz8cDmJM05R4cOJZEaMJ6j2J2QTgRHW03+/FeLvdqCgKEZxngnihClW9wtd9APIEILPj8SiIIBv8OUU2JBlbVoBZNUD/7y1hKzzUAvzBj8Tj8fi+CHWpThWdekcS8TzvcwKQkdoT0JDUfV6QkwrgnVTc09RgJoBA0Lk0vRmZJGdJcW+QrCrdSQJTACFT6rH+qhmBuJqBwccI8kIFm4C9uq7FB8V2BgqQfcEGnFFlvJJpWAruD4kj4Ag4An9X1ZrTdHPAMwAAAABJRU5ErkJggg=="
      />
      <title>DOPE SECURITY - ERROR</title>
  
      <style>
        body {
          margin: 0px;
          padding: 0px;
          color: #fff;
        }
        @media (prefers-color-scheme: dark) {
          .container {
            background-color: #1b1b1b;
            color: #fff;
          }
          ul {
            color: #fff;
          }
  
          ul li span {
            color: #999;
          }
          .url {
            color: #999;
          }
        }
  
        @media (prefers-color-scheme: light) {
          .container {
            background-color: #fff;
            color: #1b1b1b;
          }
          ul {
            color: #1b1b1b;
          }
          ul li span {
            color: #6b6b6b;
          }
          .url {
            color: #6b6b6b;
          }
        }
      </style>
    </head>
    <body>
      <div class="container"
        style="
          width: 100%;
          height: 100vh;
          display: flex;
          justify-content: center;
          align-items: center;
          font-family: Karla;
        "
      >
        <section
          style="
            display: flex;
            justify-content: center;
            align-items: flex-start;
            padding: 4px 0px;
          "
        >
          <div>
            <svg
              width="36"
              height="36"
              viewBox="0 0 36 36"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M19.681 9.29012C18.9897 7.91009 17.0203 7.90972 16.3285 9.28951L8.43395 25.035C7.80882 26.2818 8.71533 27.7504 10.1101 27.7504H25.8919C27.2863 27.7504 28.1928 26.2824 27.5683 25.0357L19.681 9.29012ZM14.3171 8.28105C15.8391 5.24554 20.1719 5.24633 21.6927 8.28241L29.58 24.0279C30.954 26.7708 28.9596 30.0004 25.8919 30.0004H10.1101C7.04163 30.0004 5.04732 26.7696 6.4226 24.0266L14.3171 8.28105Z"
                fill="#F7C839"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M18 13.5C18.8284 13.5 19.5 14.1716 19.5 15V18C19.5 18.8284 18.8284 19.5 18 19.5C17.1716 19.5 16.5 18.8284 16.5 18V15C16.5 14.1716 17.1716 13.5 18 13.5Z"
                fill="#F7C839"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M16.5 24C16.5 23.1716 17.1716 22.5 18 22.5C18.8284 22.5 19.5 23.1716 19.5 24C19.5 24.8284 18.8284 25.5 18 25.5C17.1716 25.5 16.5 24.8284 16.5 24Z"
                fill="#F7C839"
              />
            </svg>
          </div>
          <div style="padding: 0px 7px; max-width: 430px">
            <p
              style="
                font-weight: 700;
                padding: 0px;
                margin: 0px;
                margin-top: 5px;
                font-size: 25px;
                font-style: normal;
                font-weight: 600;
                line-height: 28px;
                letter-spacing: 0px;
                text-align: left;
              "
            >
              ${title}
            </p>
            <p style="font-weight: 200; font-size: smaller">
             ${message}
            </p>
            <p style="padding-top: 10px; margin-bottom: 2px; font-size: smaller">
              URL: <span class="url">https://replaceme.extension</span>
            </p>
  
            <div
              style="
                display: flex;
                justify-content: flex-end;
                align-items: center;
                margin-top: 4rem;
              "
            >
              <button
                style="
                  padding: 10px 24px;
                  background: #00aeea;
                  border: none;
                  color: #fff;
                  float: right;
                  border-radius: 1px;
                  text-transform: uppercase;
                "
                onclick="location.href='%accept_warning%';"
              >
                continue
              </button>
            </div>
          </div>
        </section>
      </div>
    </body>
  </html>
  `
}

// for custom block pages

export const html = {
  block: `<!DOCTYPE html>
  <html lang="en">
    <head>
      <meta charset="UTF-8" />
      <meta http-equiv="X-UA-Compatible" content="IE=edge" />
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      <link
        href="https://fonts.googleapis.com/css?family=Karla"
        rel="stylesheet"
      />
      <link
        rel="icon"
        type="image/png"
        sizes="16x16"
        href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAGUSURBVHgB7VbbsYIwEF3v3H+1AztQO7AEO1A7sAPtADqADqADoALoAKgAqCA3J3PDhJCg6Ac/OTM7mbx2j5s9iysiYrQgfmhhOAKOgCOwOIFfdXI6nehyuRgPdl1HeZ5TlmVUVRXZcD6fB/P1ek3b7VbciePYeIdJu16v7B0EQcB2ux1T72IeRdFoHbbZbFiSJCwMw9HeJIGyLIU1TTMigXU1GJzz7JkCDAi+TQABdAfP53NAAr9K7gP3+91KAMaf53MC0nQSvG56AnpWTE+hr81Wge/71LZtPz8cDmJM05R4cOJZEaMJ6j2J2QTgRHW03+/FeLvdqCgKEZxngnihClW9wtd9APIEILPj8SiIIBv8OUU2JBlbVoBZNUD/7y1hKzzUAvzBj8Tj8fi+CHWpThWdekcS8TzvcwKQkdoT0JDUfV6QkwrgnVTc09RgJoBA0Lk0vRmZJGdJcW+QrCrdSQJTACFT6rH+qhmBuJqBwccI8kIFm4C9uq7FB8V2BgqQfcEGnFFlvJJpWAruD4kj4Ag4An9X1ZrTdHPAMwAAAABJRU5ErkJggg=="
      />
      <title>Access Blocked</title>
  
      <style>
        body {
          margin: 0px;
          padding: 0px;
          color: #fff;
        }
        
        .primary-action {
          padding: 10px 32px;
          background: #00AEEA;
          border: none;
          color: #fff;
          float: right;
          border-radius: 2px;
          margin-top: 40px;
          font-weight: 700;
          font-size: 14px;
          line-height: 16px;
          text-transform: uppercase;
          letter-spacing: 0.75px;
          cursor: pointer;
        }

        .title {
          font-family: 'Karla';
          font-style: normal;
          font-weight: 700;
          padding: 0px;
          margin: 0px;
          margin-top: 5px;
          font-size: 24px;
          line-height: 28px;
          letter-spacing: 0px;
          text-align: left;
        }

        .body-message, .problem-label {
          font-weight: 400;
          font-size: 14px;
          line-height: 138.3%;
        }

        .url-label {
          font-family: 'Karla';
          font-style: normal;
          font-weight: 400;
          font-size: 14px;
          line-height: 138.3%;            
        }

        .url-section {
          margin: 32px 0px 24px 0px;
          font-size: 14px;
          font-weight: 400;
          line-height: 138.3%;
        }

        .url {
          color: #ff685f;
        }

        @media (prefers-color-scheme: dark) {
          .container {
            background-color: #1b1b1b;
            color: #fff;
          }
          ul {
            color: #fff;
          }
  
          ul li span {
            color: #999;
          }
          .svglock {
            stroke: #fff;
            stroke-width: 1.5px;
            stroke-linecap: round;
            stroke-linejoin: round;
          }

          .line-color {
            background: #F7F9FA;
          }

          .title, .body-message {
            color: #FFFFFF;
          }

          .problem-label, .url-section {
            color: #F7F9FA;
          }
        }
  
        @media (prefers-color-scheme: light) {
          .container {
            background-color: #fff;
            color: #1b1b1b;
          }
          ul {
            color: #1b1b1b;
          }
          ul li span {
            color: #6b6b6b;
          }
          .svglock {
            stroke: #1b1b1b;
            stroke-width: 1.5px;
            stroke-linecap: round;
            stroke-linejoin: round;
          }

          .line-color {
            background: #919699;
          }

          .title {
            color: #1E242B;
          }

          .body-message {
            color: #10151B;
          }

          .problem-label, .url-section {
            color: #919699;
          }
        }
      </style>
    </head>
    <body>
      <div
        class="container"
        style="
          width: 100%;
          height: 100vh;
          display: flex;
          justify-content: center;
          align-items: center;
          font-family: Karla;
        "
      >
        <section
          style="display: flex; justify-content: center; align-items: flex-start"
        >
          <div>
            <svg
              width="36"
              height="36"
              viewBox="0 0 36 36"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              class="svglock"
            >
              <path
                d="M8.625 17.625C8.625 16.7966 9.29657 16.125 10.125 16.125H25.875C26.7034 16.125 27.375 16.7966 27.375 17.625V25.875C27.375 27.5319 26.0319 28.875 24.375 28.875H11.625C9.96815 28.875 8.625 27.5319 8.625 25.875V17.625Z"
              />
              <path
                d="M11.625 15.75V15.514C11.625 13.1722 11.4841 10.5619 13.1197 8.88585C14.0524 7.93005 15.5618 7.125 18 7.125C20.4382 7.125 21.9476 7.93005 22.8803 8.88585C24.5159 10.5619 24.375 13.1722 24.375 15.514V15.75"
              />
            </svg>
          </div>
          <div style="padding: 0px 8px; max-width: 430px">
            <p class="title">
              Content blocked by your organization
            </p>
            <p class="body-message" style="margin-top: 16px;">
              This content is not allowed per policy.
            </p>
            <div class="url-section">
              <p class="url-label" style="margin:0px;">
                URL: <span class="url">%destination%</span>
              </p>
              <p class="url-label" style="margin:0px;">
                CATEGORY: <span class="url">%category%</span>
              </p>
            </div>
  
            <hr
              style="
                position: relative;
                border: none;
                height: 0.5px;
              "
              class="line-color"
            />
            <p class="problem-label" style="margin-top: 24px;">Problem? Contact your administrator.</p>
            <!-- <ul style="padding-left: 40px; font-size: smaller">
              <li>
                <span style="text-decoration: underline"
                  >This category is incorrect</span
                >
                <svg
                  width="24"
                  height="8"
                  viewBox="0 0 24 8"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  style="margin-left: 5px"
                >
                  <path
                    d="M23.3536 4.35355C23.5488 4.15829 23.5488 3.84171 23.3536 3.64645L20.1716 0.464466C19.9763 0.269204 19.6597 0.269204 19.4645 0.464466C19.2692 0.659728 19.2692 0.976311 19.4645 1.17157L22.2929 4L19.4645 6.82843C19.2692 7.02369 19.2692 7.34027 19.4645 7.53553C19.6597 7.7308 19.9763 7.7308 20.1716 7.53553L23.3536 4.35355ZM0 4.5H23V3.5H0V4.5Z"
                    fill="#919699"
                  />
                </svg>
              </li>
              <li style="margin-top: 7px">
                <span style="text-decoration: underline; padding-top: 5px"
                  >I need this for work</span
                >
                <svg
                  width="24"
                  height="8"
                  viewBox="0 0 24 8"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  style="margin-left: 5px"
                >
                  <path
                    d="M23.3536 4.35355C23.5488 4.15829 23.5488 3.84171 23.3536 3.64645L20.1716 0.464466C19.9763 0.269204 19.6597 0.269204 19.4645 0.464466C19.2692 0.659728 19.2692 0.976311 19.4645 1.17157L22.2929 4L19.4645 6.82843C19.2692 7.02369 19.2692 7.34027 19.4645 7.53553C19.6597 7.7308 19.9763 7.7308 20.1716 7.53553L23.3536 4.35355ZM0 4.5H23V3.5H0V4.5Z"
                    fill="#919699"
                  />
                </svg>
              </li>
            </ul> -->
            <button class="primary-action" id="primary_action_button" onclick="history.back()">
              GO BACK
            </button>
          </div>
        </section>
      </div>
    </body>
  </html>
  `,
  warning: `<!DOCTYPE html>
  <html lang="en">
    <head>
      <meta charset="UTF-8" />
      <meta http-equiv="X-UA-Compatible" content="IE=edge" />
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      <link
        href="https://fonts.googleapis.com/css?family=Karla"
        rel="stylesheet"
      />
      <link
        rel="icon"
        type="image/png"
        sizes="16x16"
        href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAGUSURBVHgB7VbbsYIwEF3v3H+1AztQO7AEO1A7sAPtADqADqADoALoAKgAqCA3J3PDhJCg6Ac/OTM7mbx2j5s9iysiYrQgfmhhOAKOgCOwOIFfdXI6nehyuRgPdl1HeZ5TlmVUVRXZcD6fB/P1ek3b7VbciePYeIdJu16v7B0EQcB2ux1T72IeRdFoHbbZbFiSJCwMw9HeJIGyLIU1TTMigXU1GJzz7JkCDAi+TQABdAfP53NAAr9K7gP3+91KAMaf53MC0nQSvG56AnpWTE+hr81Wge/71LZtPz8cDmJM05R4cOJZEaMJ6j2J2QTgRHW03+/FeLvdqCgKEZxngnihClW9wtd9APIEILPj8SiIIBv8OUU2JBlbVoBZNUD/7y1hKzzUAvzBj8Tj8fi+CHWpThWdekcS8TzvcwKQkdoT0JDUfV6QkwrgnVTc09RgJoBA0Lk0vRmZJGdJcW+QrCrdSQJTACFT6rH+qhmBuJqBwccI8kIFm4C9uq7FB8V2BgqQfcEGnFFlvJJpWAruD4kj4Ag4An9X1ZrTdHPAMwAAAABJRU5ErkJggg=="
      />
      <title>Warning</title>
  
      <style>
        body {
          margin: 0px;
          padding: 0px;
          color: #fff;
        }

        .primary-action {
          padding: 10px 32px;
          background: #00AEEA;
          border: none;
          color: #fff;
          float: right;
          border-radius: 2px;
          margin-top: 40px;
          font-weight: 700;
          line-height: 16px;
          font-size: 14px;
          text-transform: uppercase;
          letter-spacing: 0.75px;
          cursor: pointer;
        }

        .title {
          font-family: 'Karla';
          font-style: normal;
          font-weight: 700;
          padding: 0px;
          margin: 0px;
          margin-top: 5px;
          font-size: 24px;
          line-height: 28px;
          letter-spacing: 0px;
          text-align: left;
        }

        .txt {
          padding: 10px 32px;
          font-weight: 700;
          line-height: 16px;
          font-size: 14px;
          color: #5E6366;
          margin-top: 40px;
          margin-right: 12px;
          border: none;
          background-color: transparent;
          text-transform: uppercase;
          letter-spacing: 0.75px;
          cursor: pointer;
        }

        .body-message, .problem-label, .url-label {
          font-family: 'Karla';
          font-style: normal;
          font-weight: 400;
          font-size: 14px;
          line-height: 138.3%;
        }

        .url-section {
          margin: 32px 0px 0px 0px;
          font-size: 14px;
        }

        @media (prefers-color-scheme: dark) {
          .container {
            background-color: #1b1b1b;
            color: #fff;
          }
          ul {
            color: #fff;
          }
  
          ul li span {
            color: #999;
          }

          .title, .body-message {
            color: #FFFFFF;
          }

          .problem-label, .url-section, .url-label {
            color: #F7F9FA;
          }

          .url {
            color: #919699;
          }
        }
  
        @media (prefers-color-scheme: light) {
          .container {
            background-color: #fff;
            color: #1b1b1b;
          }
          ul {
            color: #1b1b1b;
          }
          ul li span {
            color: #6b6b6b;
          }

          .title {
            color: #1E242B;
          }

          .body-message {
            color: #10151B;
          }

          .problem-label, .url-section, .url-label {
            color: #919699;
          }

          .url {
            color: #ff685f;
          }
        }
      </style>
    </head>
    <body>
      <div
        class="container"
        style="
          width: 100%;
          height: 100vh;
          display: flex;
          justify-content: center;
          align-items: center;
          font-family: Karla;
        "
      >
        <section
          style="
            display: flex;
            justify-content: center;
            align-items: flex-start;
            padding: 4px 0px;
          "
        >
          <div>
            <svg
              width="36"
              height="36"
              viewBox="0 0 36 36"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M19.681 9.29012C18.9897 7.91009 17.0203 7.90972 16.3285 9.28951L8.43395 25.035C7.80882 26.2818 8.71533 27.7504 10.1101 27.7504H25.8919C27.2863 27.7504 28.1928 26.2824 27.5683 25.0357L19.681 9.29012ZM14.3171 8.28105C15.8391 5.24554 20.1719 5.24633 21.6927 8.28241L29.58 24.0279C30.954 26.7708 28.9596 30.0004 25.8919 30.0004H10.1101C7.04163 30.0004 5.04732 26.7696 6.4226 24.0266L14.3171 8.28105Z"
                fill="#F7C839"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M18 13.5C18.8284 13.5 19.5 14.1716 19.5 15V18C19.5 18.8284 18.8284 19.5 18 19.5C17.1716 19.5 16.5 18.8284 16.5 18V15C16.5 14.1716 17.1716 13.5 18 13.5Z"
                fill="#F7C839"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M16.5 24C16.5 23.1716 17.1716 22.5 18 22.5C18.8284 22.5 19.5 23.1716 19.5 24C19.5 24.8284 18.8284 25.5 18 25.5C17.1716 25.5 16.5 24.8284 16.5 24Z"
                fill="#F7C839"
              />
            </svg>
          </div>
          <div style="padding: 0px 7px; max-width: 430px">
            <p class="title">
              Are you sure you want to continue?
            </p>
            <p class="body-message" style="margin-top: 16px;">
              Although access to this site is conditionally permitted, it should be for work purposes only.
            </p>
            <div class="url-section">
              <p class="url-label" style="margin:0px;">
                URL: <span class="url">%destination%</span>
              </p>
              <p class="url-label" style="margin:0px;">
                CATEGORY: <span class="url">%category%</span>
              </p>
            </div>
  
            <hr
            style="
              position: relative;
              border: none;
              height: 0.5px;
              background: #919699;
            "
          />
  
          <p class="problem-label" style="margin-top: 24px;">Problem? Contact your administrator.</p>
            <div
              style="
                display: flex;
                justify-content: flex-end;
                align-items: center;
              "
            >
              <button class="txt" id="secondary_action_button" onclick="history.back()">
                go back
              </button>
              <button class="primary-action" id="primary_action_button" onclick="location.href='%accept_warning%';">
                continue
              </button>
            </div>
          </div>
        </section>
      </div>
    </body>
  </html>
  `,
}

const categoryReplacer = '%category%'

const getMessageElement = (message: string, replacee: string): string => {
  const strParts = message.split(replacee)
  return strParts.join(`<span style="color: #ff685f;">${replacee}</span>`)
}
